module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_1_01-68b8f8a026fd496ffdcc81b68448647c.jpg";